import {Injectable} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

export type AppLanguage = 'de' | 'en';

@Injectable({providedIn: 'root'})
export class LanguageService {
    private readonly storageKey = 'app-language';
    private readonly defaultLang: AppLanguage = 'de';

    constructor(private readonly translate: TranslateService) {
        this.translate.addLangs(['de', 'en']);
    }

    init() {
        const lang = this.getStoredLanguage();
        this.translate.use(lang);
    }

    setLanguage(lang: AppLanguage) {
        localStorage.setItem(this.storageKey, lang);
        this.translate.use(lang);
    }

    getCurrentLanguage(): AppLanguage {
        const current = this.translate.currentLang() || this.translate.fallbackLang();
        return current === 'en' ? 'en' : 'de';
    }

    private getStoredLanguage(): AppLanguage {
        const stored = localStorage.getItem(this.storageKey);
        return stored === 'en' ? 'en' : this.defaultLang;
    }
}
